"use client";

import { c as _c } from "react/compiler-runtime";
import { Container, InfiniteMarquee, HeroCursor, SectionSubHeading, SectionTitle, SpinningBadge } from "@/components";
import ScrollExpandVideo from "@/components/animations/ScrollExpandVideo";
import { bannerVideo, bannerVideoDesktopSources, bannerVideoMobileSources } from "@/data/VideoData";
import { useDeferredVideo } from "@/hooks/media/useDeferredVideo";
import { HeroFlowerIcon, HeroStarIcon } from "@/assets/icons/MainPageIcon";
import { bannerMarquee } from "@/data/FeatureGalleryData";
import { useRef, useState, useCallback } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { motion } from "framer-motion";
const Banner = () => {
  const $ = _c(34);
  const mobileVideoRef = useRef(null);
  const desktopVideoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  useDeferredVideo(mobileVideoRef, bannerVideoMobileSources);
  useDeferredVideo(desktopVideoRef, bannerVideoDesktopSources);
  let t0;
  if ($[0] !== isMuted) {
    t0 = () => {
      const newMuted = !isMuted;
      setIsMuted(newMuted);
      if (mobileVideoRef.current) {
        mobileVideoRef.current.muted = newMuted;
      }
      if (desktopVideoRef.current) {
        desktopVideoRef.current.muted = newMuted;
      }
    };
    $[0] = isMuted;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleAudio = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 style={{
      position: "absolute",
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      border: 0
    }}>Octarnal — digital solutions agency building high-performance websites, SaaS products, and brands that stand out.</h1>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SectionSubHeading subtitle="Octarnal Creative Studio" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SectionTitle title="Building" className="text-[9vw]! md:text-[10vw]! lg:text-[9vw]! xl:text-[10vw]! 2xl:text-[150px]! whitespace-nowrap" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="shrink-0 w-[10vw] h-[10vw] lg:w-[9vw] lg:h-[9vw] xl:w-28 xl:h-28 2xl:w-32 2xl:h-32 bg-primary-foreground flex items-center justify-center rounded-xs lg:ml-2"><HeroStarIcon className="w-3/4 h-3/4 animate-[spin_10s_linear_infinite]" /></div>;
    t5 = <SectionTitle title="Brands" className="text-[9vw]! md:text-[10vw]! lg:text-[9vw]! xl:text-[10vw]! 2xl:text-[140px]! whitespace-nowrap" />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HeroCursor label="Research" color="#7CD4FD" className="absolute left-[40%] top-[40%] md:top-[55%] xl:left-[43%] 2xl:left-[40%] " rangeX={[-60, 60]} rangeY={[-40, 40]} />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative flex items-center flex-nowrap">{t3}{t4}{t5}{t6}<HeroCursor label="Design" color="#F4D3D3" className="absolute right-6 top-[40%] md:top-[50%] md:right-[5%] lg:right-[10%] xl:right-[8%]" rangeX={[20, -60]} rangeY={[40, -40]} /></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="w-[10vw] h-[10vw] lg:w-[9vw] lg:h-[9vw] xl:w-28 xl:h-28 2xl:w-32 2xl:h-32 bg-primary-foreground flex items-center justify-center rounded-xs ml-2"><HeroFlowerIcon className="w-3/4 h-3/4 animate-[spin_5s_linear_infinite]" /></div>;
    t9 = <SectionTitle title="That Stand Out" className="text-[9vw]! md:text-[10vw]! lg:text-[9vw]! xl:text-[10vw]! 2xl:text-[140px]! whitespace-nowrap" />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Container className="relative lg:px-10 px-5  md:mb-25 lg:mb-30 mb-12">{t2}{t7}<div className="relative flex items-center gap-1 flex-wrap mt-[1vw]">{t8}{t9}<div className="absolute right-0 bottom-[-80%] md:right-[-2%] md:-bottom-[120%]  lg:right-[5%] lg:bottom-[-70%] xl:right-[3%] xl:bottom-[-70%] 2xl:-bottom-30 z-10 w-[20vw] h-[20vw] md:w-[20vw] md:h-[20vw] lg:w-[12vw] lg:h-[12vw] lg:scale-100 md:scale-75 scale-30 2xl:w-45 2xl:h-45"><SpinningBadge /></div><HeroCursor label="Software" color="#00FF94" className="absolute left-[20%] -bottom-[30%] md:-bottom-[15%] md:left-[16%] xl:left-[13%]" /></div></Container>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <video ref={mobileVideoRef} poster={bannerVideo?.poster} preload="none" title={bannerVideo.title} aria-label={bannerVideo.title} loop={true} muted={true} playsInline={true} className="w-full h-full object-cover bg-black/5" />;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = isMuted ? "Unmute video" : "Mute video";
  let t13;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      rotate: 360
    };
    t14 = {
      duration: 12,
      repeat: Infinity,
      ease: "linear"
    };
    $[13] = t13;
    $[14] = t14;
  } else {
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <path id="audioCircleMobile" d="M 50, 50 m -38, 0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" fill="none" />;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  const t16 = isMuted ? "\u2022 LISTEN \u2022 UNMUTE \u2022 LISTEN \u2022 UNMUTE " : "\u2022 PLAYING \u2022 AUDIO \u2022 PLAYING \u2022 AUDIO ";
  let t17;
  if ($[16] !== t16) {
    t17 = <motion.div animate={t13} transition={t14} className="absolute inset-0"><svg viewBox="0 0 100 100" className="w-full h-full" aria-hidden="true">{t15}<text className="text-[11px] uppercase font-black tracking-[0.25em] fill-primary"><textPath xlinkHref="#audioCircleMobile">{t16}</textPath></text></svg></motion.div>;
    $[16] = t16;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] !== isMuted) {
    t18 = <div className="relative z-10 w-9 h-9 md:w-11 md:h-11 rounded-full bg-primary flex items-center justify-center shadow-lg">{isMuted ? <VolumeX className="w-4 h-4 md:w-5 md:h-5 text-accent-foreground" /> : <Volume2 className="w-4 h-4 md:w-5 md:h-5 text-accent-foreground" />}</div>;
    $[18] = isMuted;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  let t19;
  if ($[20] !== t17 || $[21] !== t18) {
    t19 = <div className="relative w-16 h-16 md:w-20 md:h-20 flex items-center justify-center">{t17}{t18}</div>;
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== t12 || $[24] !== t19 || $[25] !== toggleAudio) {
    t20 = <div className="lg:hidden w-full flex justify-center"><div className="relative w-[90%] aspect-video overflow-hidden">{t11}<button onClick={toggleAudio} className="absolute bottom-4 right-4 z-20" aria-label={t12}>{t19}</button></div></div>;
    $[23] = t12;
    $[24] = t19;
    $[25] = toggleAudio;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="flex flex-col gap-16"><InfiniteMarquee items={bannerMarquee} speed={15} direction="left" className="h-16 flex items-center" imageClassName="h-12 w-auto" innerClassName="object-contain h-12 w-auto grayscale hover:grayscale-0 transition-all duration-500 ease-in-out" isImageFill={false} sizes="260px" gap="gap-8 lg:gap-10" /></div>;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] !== isMuted || $[29] !== toggleAudio) {
    t22 = <div className="hidden lg:block"><ScrollExpandVideo data={bannerVideo} videoRef={desktopVideoRef} onToggleAudio={toggleAudio} isMuted={isMuted} marqueeContent={t21} /></div>;
    $[28] = isMuted;
    $[29] = toggleAudio;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] !== t20 || $[32] !== t22) {
    t23 = <section className="relative pt-6 pb-12 md:pt-8 md:pb-16 lg:pt-10 cursor-default">{t1}{t10}{t20}{t22}</section>;
    $[31] = t20;
    $[32] = t22;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  return t23;
};
export default Banner;